import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import "dayjs/locale/it";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.locale("it");

const memoized = {};
export const decode = (str) => {
  if (!str) return str;
  if (!memoized[str]) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    memoized[str] = txt.value;
  }
  return memoized[str];
};

export const getPageFind = () => import(/* webpackIgnore: true */ "/pagefind/pagefind.js");
export const preload = async (query, options) => {
  if (process.env.EDIT_MODE !== "true") {
    const pagefind = await getPageFind();
    pagefind.preload(query, options);
  }
};
export const ALL_MODES = [
  {
    label: "Mensile",
    value: "mensile",
  },
  {
    label: "Giornaliera",
    value: "giornaliera",
  },
];
export const MODES = ALL_MODES.map((item) => item.value);
export const getMode = (options) => {
  const { query, searchFrom, searchTo, mode } =
    options instanceof URLSearchParams
      ? {
          query: options.get("query"),
          searchFrom: options.get("search-from"),
          searchTo: options.get("search-to"),
          mode: options.get("mode"),
        }
      : {
          ...options,
        };
  return mode || (!query && !searchFrom && !searchTo ? MODES[0] : null);
};

export const filterByDates = (from, to) => {
  const start = dayjs(from, "DD/MM/YYYY");
  const end = dayjs(to, "DD/MM/YYYY");
  return (item) => {
    if (item.meta?.dateSingle) {
      const dateSingle = dayjs(item.meta.dateSingle);
      return dateSingle.isBetween(start, end, "day", "[]");
    } else if (item.meta?.dateFrom && item.meta?.dateTo) {
      const dateFrom = dayjs(item.meta.dateFrom, "YYYYMMDD");
      const dateTo = dayjs(item.meta.dateTo, "YYYYMMDD");
      return (
        dateFrom.isBetween(start, end, "day", "[]") ||
        dateTo.isBetween(start, end, "day", "[]") ||
        start.isBetween(dateFrom, dateTo, "day", "[]") ||
        end.isBetween(dateFrom, dateTo, "day", "[]")
      );
    }
    return false;
  };
};

export const splitByWeek = (results, current) => {
  const date =
    current && dayjs(current, "MM/YYYY", true).isValid() ? dayjs(current, "MM/YYYY") : dayjs();
  const firstDay = date.startOf("month");
  const lastDay = date.endOf("month");
  const weeks = [];
  let day = firstDay;
  do {
    const endWeek = day.endOf("week");
    const end = endWeek.isBefore(lastDay) ? endWeek : lastDay;
    weeks.push([day, end]);
    day = end.add(1, "day");
  } while (day.isBefore(lastDay, "day"));
  const rows = [];
  for (const [start, end] of weeks) {
    rows.push(
      results.filter((item) => {
        const dateSingle = item.meta?.dateSingle ? dayjs(item.meta.dateSingle) : null;
        if (dateSingle) {
          return dateSingle.isBetween(start, end, "day", "[]");
        } else if (item.meta?.dateFrom && item.meta?.dateTo) {
          const dateFrom = dayjs(item.meta.dateFrom, "YYYYMMDD");
          const dateTo = dayjs(item.meta.dateTo, "YYYYMMDD");
          return (
            dateFrom.isBetween(start, end, "day", "[]") ||
            dateTo.isBetween(start, end, "day", "[]") ||
            start.isBetween(dateFrom, dateTo, "day", "[]") ||
            end.isBetween(dateFrom, dateTo, "day", "[]")
          );
        }
        return false;
      })
    );
  }
  return rows.filter((row) => !!row.length);
};

export const filterByDay = (results, current) => {
  const day =
    current && dayjs(current, "DD/MM/YYYY", true).isValid()
      ? dayjs(current, "DD/MM/YYYY")
      : dayjs();
  return results.filter((item) => {
    const dateSingle = item.meta?.dateSingle ? dayjs(item.meta.dateSingle) : null;
    if (dateSingle) {
      return dateSingle.isSame(day, "day");
    } else if (item.meta?.dateFrom && item.meta?.dateTo) {
      const dateFrom = dayjs(item.meta.dateFrom, "YYYYMMDD");
      const dateTo = dayjs(item.meta.dateTo, "YYYYMMDD");
      return (
        day.isBetween(dateFrom, dateTo, "day", "[]") || day.isBetween(dateFrom, dateTo, "day", "[]")
      );
    }
    return false;
  });
};
